import { Component, OnInit,ElementRef, ViewChild,NgZone,ViewEncapsulation,OnChanges, OnDestroy,Input, Output,SimpleChanges,EventEmitter} from '@angular/core';
import { FrmService } from '../inservice/frm.service';
import { ChangeDetectorRef, AfterContentChecked} from '@angular/core';
import {BrowserModule, DomSanitizer, Title} from '@angular/platform-browser'
import { CookieService } from '../_services/cookie.service';
import { InjectDirective } from '../_directive/inject.directive';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {DatePipe} from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-frm',
  templateUrl: './frm.component.html',
  styleUrls: ['./frm.component.css']
})
export class FrmComponent implements OnInit {
  @Input() lockId:string;
  @Input() inputData:any;
  @Input() src:string;
  @Input() pcaData:any;
  @Input() rterm:number;
  @Input() pquan:number;
  @Input() costs:any[];
  @Input() RF:any[];
  @Input() rfinfo:any;
  @Input() ulProp:any;
  @Input() frmSign:any;
  @Input() users:number
  @Input() updateFrmData:any;
  @Output() frmOutput = new EventEmitter<any>(true);
  @Output() costItem = new EventEmitter<any>(true);
  @Output() toRF = new EventEmitter<any>(true);
  @Output() toSign = new EventEmitter<boolean>(true);
  @Output() scrollOutput = new EventEmitter<string>(true);
  @Output() zoom = new EventEmitter<string>(true);
  @Output() secSwitch = new EventEmitter<string>(true);
  public PropertyAsReported:any;
  public PropertyAsReportedHTML:any;  
  public PropertyConditionAssessmentPropertyCoreCharacteristics:any;
  public PropertyConditionAssessmentPropertyCoreCharacteristicsHTML:any;
  public PropertyConditionAssessment:any;
  public PropertyConditionAssessmentHTML:any;
  public frmData:any;
  public PropertyAmenity:any;
  public PropertyTotalRentRollSummary:any;
  public flatDataAmentities:any;
  public flatData:any;
  public flatDataSec2:any;
  public flatDataSec3:any;
  public flatDataSetSec3:any;
  public flatDataSec4:any;
  public flatDataSetSec4:any;
  public tableset:any;
  public overallPropertyRating={'overallCondition':'','overallRating':''};
  public sec2tablesdata:any[];
  public sec3tablesdata:any[];
  public sec6tablesdata:any[];
  public pcaOp={'term':'Include','multiplier':"",'quantity':0, 'reserve':12, 'age':0, 'decimal':2,'currency':'USD','inflation':2.5,'round':'Round'};
  public costTables:any[];
  public curSec:any;	
  public curCell:any;	
  public cellShow:any;
  public datasrc:boolean;	
  public bedroomList=['0BR', '1BR', '2BR', '3BR', '4BR', '5BR'];
  public bedroomStatus=['O = occupied', 'V = vacant', 'D = down','R = Other'];
  public unitrow=1
  public ORrows=[];
  public repairTotal=0;
  //waterCheck=[false, false, false, false, false];
  waters=['privateWellsDrinkingWater','privateWellsNonDrinkingWater','wasteWaterTreatment', 'privateLiftStations'];
  date:any;
  allSecIds=['frm_sec0', 'frm_sec1', 'frm_sec2', 'frm_sec3', 'frm_sec4', 'frm_se5c', 'frm_sec6'];
  lockid:string;
  ifMulti=false;
  table6Itemkeys=[]
  constructor(private datePipe:DatePipe, public frmService:FrmService,  public sanitizer: DomSanitizer,) { 
    
    this.tableset=this.frmService.tableSet;
    if(!this.sec2tablesdata){
      
      this.sec2tablesdata=[];

    for(let rowitem of this.tableset.sec2tables.rowItem){
      let data={'cols':[],'rows':[]};
      data.cols=this.tableset.sec2tables.cols;//console.log(data.cols)
      for(let keys of rowitem){
        let row=JSON.parse(JSON.stringify(this.tableset.sec2tables.baserow));
        //console.log(row)
        for(let i=0; i<row.length; i++){
          row[i]['KEY']=data.cols[i].KEY;
        }
        row[0].data=keys.key;
        data.rows.push(row);
        if(keys.sub&&keys.sub.length>0){
          for(let subkey of keys.sub){
            let subrow=JSON.parse(JSON.stringify(this.tableset.sec2tables.baserow));
            subrow[0].data=subkey;
            subrow[0]['sub']='20px';
            subrow[0]['parent']=keys.key;
            data.rows.push(subrow);
          }
          
        }
      }      
      this.sec2tablesdata.push(data);
    }    
    // this.frmData['sec2tablesdata']=this.sec2tablesdata; 
  
    this.sec3tablesdata=[];
    for(let row of [1,2,3,4]){
      let data={'cols':[],'rows':[]};
      data.cols=this.tableset.sec3tables.cols;
      let baserow=JSON.parse(JSON.stringify(this.tableset.sec3tables.baserow));
      data.rows.push(baserow);
      let totalrow=JSON.parse(JSON.stringify(this.tableset.sec3tables.totalrow));
      data.rows.push(totalrow);  
      this.sec3tablesdata.push(data);
    }    
    //this.frmData['sec3tablesdata']=this.sec3tablesdata;      
    this.sec6tablesdata=[];
    let table6Itemkey=[]
    for(let rowitem of this.tableset.sec6tables.rowItem){
      let data={'cols':[],'rows':[]};
      data.cols=this.tableset.sec6tables.cols;
      for(let keys of rowitem){
        let row=JSON.parse(JSON.stringify(this.tableset.sec6tables.baserow));
        row[0].data=keys.key;
        table6Itemkey.push(keys.key);
        data.rows.push(row);
        if(keys.sub&&keys.sub.length>0){
          for(let subkey of keys.sub){
            let subrow=JSON.parse(JSON.stringify(this.tableset.sec6tables.baserow));
            subrow[0].data=subkey;
            subrow[0]['sub']='20px';
            subrow[0]['parent']=keys.key;
            data.rows.push(subrow);
          }
          
        }
        
      }      
      this.sec6tablesdata.push(data);
      this.table6Itemkeys.push(table6Itemkey);
    }   
    this.toTotalTabledata();
  }

  }
  ngOnChanges(changes: SimpleChanges): void {
    if('inputData' in changes){
      if(this.inputData){
        this.frmData=this.inputData;
        if(!this.frmData['sec4OutPutData']){
					this.frmData['sec4OutPutData']=[0, '$0'];
				}
        if(!this.frmData['overallPropertyRating']){
          this.frmData['overallPropertyRating']=this.overallPropertyRating;
        }
       if(this.frmData['AccountNameHTML']){
          this.AccountNameHTML=this.frmData['AccountNameHTML'];
        }
        if(this.frmData['flatPartySetSec3']){
          this.flatPartySetSec3=this.frmData['flatPartySetSec3'];
        }
        if(this.frmData['repairtCount']){
         this.repairtCount= this.frmData['repairtCount'];
        }
        
        if(this.frmData['sec2tablesdata']){
          //this.sec2tablesdata=this.frmData['sec2tablesdata'];
          for(let i=0; i<4; i++){
            for(let row of this.frmData['sec2tablesdata'][i].rows){
            if(row[0].costtable){
              let index=this.sec2tablesdata[i].rows.findIndex(item=>item[0].data==row[0].data);
              if(index>-1){
                this.sec2tablesdata[i].rows[index][0]['costtable']=row[0]['costtable'];
                this.sec2tablesdata[i].rows[index][0]['costlabel']=row[0]['costlabel'];
              }              
            }
          }
          }
          
          this.frmData['sec2tablesdata']=this.sec2tablesdata;
        }else{
          this.frmData['sec2tablesdata']=this.sec2tablesdata;
        }
        if(!this.frmData['waterCheck']){
          this.frmData['waterCheck']=this.frmService.frmData.waterCheck;
        }
        /*if(this.frmData['sec3tablesdata']){
          this.sec3tablesdata=this.frmData['sec3tablesdata'];
        }else{
          this.frmData['sec3tablesdata']=this.sec3tablesdata;
        }
        if(this.frmData['sec6tablesdata']){
          this.sec6tablesdata=this.frmData['sec6tablesdata'];          
        }else{
          this.frmData['sec6tablesdata']=this.sec6tablesdata;
        }*/
        this.PropertyAsReportedHTML=this.frmData.PropertyAsReportedHTML;
        this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML=this.frmData.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML;
        this.PropertyConditionAssessmentHTML=this.frmData.PropertyConditionAssessmentHTML;
        this.toSanitizer();
        this.PropertyAmenity=this.frmData.PropertyAmenity;
        this.PropertyAsReported=this.frmData.PropertyAsReported;
        
        this.PropertyConditionAssessmentPropertyCoreCharacteristics=this.frmData.PropertyConditionAssessmentPropertyCoreCharacteristics;
        
        this.PropertyConditionAssessment=this.frmData.PropertyConditionAssessment;
        
        this.PropertyTotalRentRollSummary=this.frmData.PropertyTotalRentRollSummary;
        this.toFlat(this.PropertyConditionAssessment[0]);
        if(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.length==0){
          let item={
            "UnitType": "",
            "SlrDesignatedUnitId": "",
            "OccupancyStatusType": ""
          }
          for(let i=0; i<20; i++){
            this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.push(JSON.parse(JSON.stringify(item)));
          }
          this.unitrow=5
        }else{
          this.unitrow=Math.ceil(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.length/4); 
          if(this.unitrow<5) {
            this.unitrow=5
          }    
        }
        
        
      }		
    }
    if('updateFrmData' in changes){
      if(this.updateFrmData&&this.updateFrmData.id){
        this.secToFrmData(this.updateFrmData);

      }
    }
    if('lockId' in changes){
      if(this.lockId&&this.lockId.length>0){
        let index=this.allSecIds.indexOf(this.lockId);
        if(index>-1){
          this.lockid=this.lockId
        }
      }
    }
    if('pcaData' in changes){
      if(this.pcaData){
        this.pcaOp=this.pcaData; 
        this.PropertyConditionAssessment[0].CapitalExpenditureMrtgTermYrCount=this.pcaOp.reserve-2;
      }
    }
    
    if('rterm' in changes){
      if(this.rterm){
        this.PropertyConditionAssessment[0].CapitalExpenditureMrtgTermYrCount=this.rterm-2;
      }
    }
    if('pquan' in changes){
      if(this.pquan){
        this.pcaOp.quantity=this.pquan;
        /*if(this.costTables&&this.costTables.length>0){          
          
        }*/  
       if(this.sec6tablesdata&&this.sec6tablesdata[5].rows[0][1]>0){
        this.toFrmTable();
       }      
      }
    }
    if('costs' in changes){
      if(this.costs){
        this.costTables=this.costs;  
        if(this.src=='rpt'){
          this.toFrmTable();
        }if(this.src=='temp'){
          this.toUL();
        } 
          
      }
    }
    if('rfinfo' in changes){//console.log(this.rfinfo)
      if(this.rfinfo&&this.rfinfo.length>=0){
        //this.AccountNameHTML=this.rfinfo;   
       // console.log(this.PropertyAsReportedHTML)
        let keys=Object.keys(this.PropertyAsReportedHTML);
        for(let key of keys){
          if(this.PropertyAsReportedHTML[key].html){//console.log(this.PropertyAsReportedHTML[key].html)
            let slotsinfo=$(this.PropertyAsReportedHTML[key].html).find('.placeholder');//console.log(slotsinfo)
            if(slotsinfo.length>0){
              for(let slot of slotsinfo){//console.log($(slot)[0].innerHTML)
                this.PropertyAsReportedHTML[key].data=this.PropertyAsReportedHTML[key].html.replaceAll($(slot)[0].outerHTML,$(slot)[0].innerHTML)
                //console.log(this.PropertyAsReportedHTML[key].data)
              }
            
            if(this.PropertyAsReportedHTML[key].html){
              this.PropertyAsReported[0][key]=$(this.PropertyAsReportedHTML[key].data)[0].innerHTML;
            }
            }else{
              if(this.PropertyAsReportedHTML[key].html){
                this.PropertyAsReported[0][key]=$(this.PropertyAsReportedHTML[key].html)[0].innerHTML;
              }
            }
          }else{
            this.PropertyAsReported[0][key]='';
          }
        }
        let keys2=Object.keys(this.PropertyConditionAssessmentHTML);
        for(let key of keys2){
          if(this.PropertyConditionAssessmentHTML[key].html){//console.log(this.PropertyAsReportedHTML[key].html)
            let slotsinfo=$(this.PropertyConditionAssessmentHTML[key].html).find('.placeholder');//console.log(slotsinfo)
            if(slotsinfo.length>0){
              for(let slot of slotsinfo){//console.log($(slot)[0].innerHTML)
                this.PropertyConditionAssessmentHTML[key].data=this.PropertyConditionAssessmentHTML[key].html.replaceAll($(slot)[0].outerHTML,$(slot)[0].innerHTML)
                //console.log(this.PropertyAsReportedHTML[key].data)
              }
            
              if(this.PropertyConditionAssessmentHTML[key].html.length>0){
                this.PropertyConditionAssessment[0][key]=$(this.PropertyConditionAssessmentHTML[key].data)[0].innerHTML;
              }
            }else{
              if(this.PropertyConditionAssessmentHTML[key].html){
                this.PropertyConditionAssessment[0][key]=$(this.PropertyConditionAssessmentHTML[key].html)[0].innerHTML;
              }
            }
          }else{
            this.PropertyConditionAssessment[0][key]='';
          }
        }
        let keys1=Object.keys(this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML);
        for(let key of keys1){
          if(this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML[key].html){//console.log(this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML[key].html)
            let slotsinfo=$(this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML[key].html).find('.placeholder');//console.log(slotsinfo)
            if(slotsinfo.length>0){
              for(let slot of slotsinfo){//console.log($(slot)[0].innerHTML)
                this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML[key].data=this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML[key].html.replaceAll($(slot)[0].outerHTML,$(slot)[0].innerHTML)
                //console.log(this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML[key].data)
              }
            
            if(this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML[key].html){
              this.PropertyConditionAssessmentPropertyCoreCharacteristics[0][key]=$(this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML[key].data)[0].innerHTML;
            }
            }else{
              if(this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML[key].html){
                this.PropertyConditionAssessmentPropertyCoreCharacteristics[0][key]=$(this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML[key].html)[0].innerHTML;
              }
            }
          }else{
            this.PropertyConditionAssessmentPropertyCoreCharacteristics[0][key]='';
          }
        }
        this.frmData.PropertyAsReported=this.PropertyAsReported;
        this.frmData.PropertyConditionAssessment=this.PropertyConditionAssessment;
        this.frmData.PropertyConditionAssessmentPropertyCoreCharacteristics=this.PropertyConditionAssessmentPropertyCoreCharacteristics;
        this.toOutput();          
      }
    }
    if('ulProp' in changes){
      if(this.ulProp){
       // this.AccountNameHTML=this.ulProp;  
       //this.toUL();
      }
    }
    if('src' in changes){
      if(this.src=='temp'){
        this.datasrc=false;       
      }else if(this.src=='rpt'){
        this.datasrc=true; 
      }
    }
    if('frmSign' in changes){
      if(this.frmSign){
        this.frmData['frmSign']=this.frmSign.SIGNATURE_URL;
        this.frmData['frmSignName']=this.frmSign.FULL_NAME;
        this.frmData['title']=this.frmSign.JOB_TITLE;
        this.frmData['firmname']=this.frmSign.COMPANY_NAME
        this.date=new Date();
        this.frmData['date']=this.date;
        this.frmOutput.emit(this.frmData);
      }
      
    }
    if('users' in changes){
      if(this.users==1){
        this.ifMulti=false;
      }else{
        this.ifMulti=true
      }
      
    }
  }
  removeSign(e){
    if(e && e.target){
			e.stopPropagation();
		}
    delete this.frmData.frmSign;
    this.frmData['frmSignName']='';
    this.frmData['title']='';
    this.frmData['firmname']='';
    this.date=null;
    this.frmData['date']='';
    this.frmOutput.emit(this.frmData);
  }
  removeName(e){
    if(e && e.target){
			e.stopPropagation();
		}
    delete this.frmData.frmSignName;
    this.frmOutput.emit(this.frmData);
  }
  addSign(e){
    if(e && e.target){
			e.stopPropagation();
		}
    this.toSign.emit(true);    
  }
  ngOnInit(): void {
    
    //new Date().getTime()
    /*this.tableset=this.frmService.tableSet;
    if(!this.sec2tablesdata){
      
      this.sec2tablesdata=[];

    for(let rowitem of this.tableset.sec2tables.rowItem){
      let data={'cols':[],'rows':[]};
      data.cols=this.tableset.sec2tables.cols;//console.log(data.cols)
      for(let keys of rowitem){
        let row=JSON.parse(JSON.stringify(this.tableset.sec2tables.baserow));
        //console.log(row)
        for(let i=0; i<row.length; i++){
          row[i]['KEY']=data.cols[i].KEY;
        }
        row[0].data=keys.key;
        data.rows.push(row);
        if(keys.sub&&keys.sub.length>0){
          for(let subkey of keys.sub){
            let subrow=JSON.parse(JSON.stringify(this.tableset.sec2tables.baserow));
            subrow[0].data=subkey;
            subrow[0]['sub']='20px';
            data.rows.push(subrow);
          }
          
        }
      }      
      this.sec2tablesdata.push(data);//console.log(this.sec2tablesdata)
    }
    
     
  
    this.sec3tablesdata=[];
    for(let row of [1,2,3,4]){
      let data={'cols':[],'rows':[]};
      data.cols=this.tableset.sec3tables.cols;
      let baserow=JSON.parse(JSON.stringify(this.tableset.sec3tables.baserow));
      data.rows.push(baserow);
      let totalrow=JSON.parse(JSON.stringify(this.tableset.sec3tables.totalrow));
      data.rows.push(totalrow);  
      this.sec3tablesdata.push(data);//console.log(this.sec3tablesdata)
    }
    this.frmData['sec2tablesdata']=this.sec2tablesdata; 
    this.frmData['sec3tablesdata']=this.sec3tablesdata;      
    this.sec6tablesdata=[];
    for(let rowitem of this.tableset.sec6tables.rowItem){
      let data={'cols':[],'rows':[]};
      data.cols=this.tableset.sec6tables.cols;
      for(let keys of rowitem){
        let row=JSON.parse(JSON.stringify(this.tableset.sec6tables.baserow));
        row[0].data=keys.key;
        data.rows.push(row);
        if(keys.sub&&keys.sub.length>0){
          for(let subkey of keys.sub){
            let subrow=JSON.parse(JSON.stringify(this.tableset.sec6tables.baserow));
            subrow[0].data=subkey;
            subrow[0]['sub']='20px';
            data.rows.push(subrow);
          }
          
        }
      }      
      this.sec6tablesdata.push(data);//console.log(this.sec6tablesdata)
      
    }
    this.toTotalTabledata();
    
  }*/
    //this.frmData=this.frmService.frmData;console.log(this.frmData);
    //this.PropertyAmenity=this.frmData.PropertyAmenity;
   // this.PropertyAsReported=this.frmData.PropertyAsReported;
   // this.PropertyConditionAssessmentPropertyCoreCharacteristics=this.frmData.PropertyConditionAssessmentPropertyCoreCharacteristics;
   // this.PropertyConditionAssessment=this.frmData.PropertyConditionAssessment;
   // this.PropertyTotalRentRollSummary=this.frmData.PropertyTotalRentRollSummary;
    /*let sectionSet=this.frmService.sectionSet;
		let subSectionSet=this.frmService.subSectionSet;
		let childrenSet=this.frmService.childrenSet;
		let dataCat=this.frmService.dataCat;console.log(dataCat)
    let tableSet=this.frmService.tableSet;
		//let htmlSet=this.frmService.htmlSet;
		let JsonSet=this.frmService.JsonSet;
    for(let items of sectionSet){
			items.SUB_SECTIONS=subSectionSet.frm_sec0;
			for(let i=0; i<items.SUB_SECTIONS.length; i++){
				let doc1=items.SUB_SECTIONS[i];
				for(let j=0; j<doc1.SUB_SECTIONS.length; j++){
					let subitem=doc1.SUB_SECTIONS[j]; console.log(i-1, subitem);
					if(subitem.TYPE=='1105-table'){console.log(doc1.id);console.log(items.id);
						console.log(tableSet[doc1.id]);
						console.log(tableSet[items.id]);
						if(tableSet[doc1.id]||tableSet[items.id]){
							if(tableSet[doc1.id]){
								subitem['data']=JSON.parse(JSON.stringify(tableSet[doc1.id]));
							}else if(tableSet[items.id]){
								subitem['data']=JSON.parse(JSON.stringify(tableSet[items.id]));
							}
							
							let baserow=JSON.parse(JSON.stringify(subitem.data['rows'][0]));
							subitem.data['rows']=[];
							let dataset=[];
							console.log(i,j)
							if(items.id=='frm_sec1'){
								dataset=dataCat[i-1];
							}else if(doc1.id=='frm_sec5_1'){
								dataset=dataCat[j];
							}
							console.log(dataset)
							for(let row of dataset){
								let item=JSON.parse(JSON.stringify(baserow));
								item[0].data=row.label;
								subitem.data['rows'].push(item);
								if(row['sub']){
									for(let subrow of row['sub']){
										let item1=JSON.parse(JSON.stringify(baserow));
										item1[0].data=subrow.label;
										item1[0]['sub']=true;
										subitem.data['rows'].push(item1);
									}
								}
							}							
						}
						console.log(subitem.data)						
					}
				}
			
			}
		}*/

  }
  toFlat(alldata){
    this.flatDataAmentities=[];
    for(let data of this.PropertyAmenity){
      this.flatDataAmentities.push(data.AmenityType);
    }
    
    this.flatData=[];
    for(let data of alldata.PropertyConditionAssessmentBuildingAndMaterials){
       if(data.CatSubtype){
          let text=data.CatType+';'+data.CatSubtype+';'+data.ItemType;
          this.flatData.push(text);
        }else{
          let text=data.CatType+';'+data.ItemType
          this.flatData.push(text);
        }    
    }
   // console.log(this.flatData);
    this.flatDataSec3={};
    this.flatDataSetSec3={};
    for(let i=0; i<this.waters.length; i++){
     // if(i==1){
      //   let item={"PptyWaterSystemType": "privateWellsNonDrinkingWater",
       //   "WaterSystemOperationsDescription": ""};
      //    this.flatDataSec3[this.waters[i]]=['privateWellsNonDrinkingWater'];
      //    this.flatDataSetSec3[this.waters[i]]=[item];               
      //}else{
        this.flatDataSec3[this.waters[i]]=[];
        this.flatDataSetSec3[this.waters[i]]=[]; 
     // }      
    }
    for(let data of alldata.PropertyConditionAssessmentWaterTreatment){
      if(this.flatDataSec3[data.PptyWaterSystemType]){
        if(data['WaterSystemMaintenanceResponsiblePartyType']==''||data['WaterSystemMaintenanceResponsiblePartyType']){
          this.flatDataSec3[data.PptyWaterSystemType].push('PptyWaterSystemSubTypeInfo');
        }else if(data.PptyWaterSystemSubType){
          this.flatDataSec3[data.PptyWaterSystemType].push(data.PptyWaterSystemSubType);
        }else{
          this.flatDataSec3[data.PptyWaterSystemType].push(data.WaterSystemAsmntItemType);
          
        }
        if(data.PptyWaterSystemType=='privateWellsNonDrinkingWater'){
          this.flatDataSetSec3[data.PptyWaterSystemType][0]=data;
        }else{
          this.flatDataSetSec3[data.PptyWaterSystemType].push(data);
        }
        
      }else{
        this.flatDataSec3[data.PptyWaterSystemType]=[];
        this.flatDataSetSec3[data.PptyWaterSystemType]=[];
        this.flatDataSetSec3[data.PptyWaterSystemType].push(data);

        if(data['WaterSystemMaintenanceResponsiblePartyType']==''||data['WaterSystemMaintenanceResponsiblePartyType']){console.log(data)
          this.flatDataSec3[data.PptyWaterSystemType].push('PptyWaterSystemSubTypeInfo');          
        }else if(data.PptyWaterSystemSubType){
          this.flatDataSec3[data.PptyWaterSystemType].push(data.PptyWaterSystemSubType);
        }else{
          this.flatDataSec3[data.PptyWaterSystemType].push(data.WaterSystemAsmntItemType);
          
        }
      }
      

    }
    /*for(let i=0; i<this.waters.length; i++){
        if(this.frmData.waterCheck[i]){
          if(!this.flatDataSec3[this.waters[i]]){
            this.flatDataSec3[this.waters[i]]=[];
          }
          if(this.flatDataSetSec3[this.waters[i]]){
            this.flatDataSetSec3[this.waters[i]]=[];
          }
          if(!this.flatPartySetSec3[this.waters[i]]){
            this.flatPartySetSec3[this.waters[i]]={};
          }
                 
        }
      }*/
    //console.log(this.flatDataSec3);
   // console.log(this.flatDataSetSec3);
    this.flatDataSec4={};
    this.flatDataSetSec4={};
    if(alldata.PropertyConditionAssessmentManufacturedHousing.length>0){
      for(let data of alldata.PropertyConditionAssessmentManufacturedHousing){
        if(this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"]){
          this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"].push(data.ViolationType);
          this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"].push(data);
        }else{
          this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
          this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
          this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"].push(data);
          this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"].push(data.ViolationType);
            
          
        }
      }
    }else{
      this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
      this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
    }
    if(alldata.ManufacturedHousingUtility.length>0){
      for(let data of alldata.ManufacturedHousingUtility){
        if(this.flatDataSec4['ManufacturedHousingUtility']){
          this.flatDataSec4['ManufacturedHousingUtility'].push(data.UtilityServiceType);
          this.flatDataSetSec4['ManufacturedHousingUtility'].push(data);
        }else{
          this.flatDataSec4['ManufacturedHousingUtility']=[];
          this.flatDataSetSec4['ManufacturedHousingUtility']=[];
          this.flatDataSetSec4['ManufacturedHousingUtility'].push(data);
          this.flatDataSec4['ManufacturedHousingUtility'].push(data.UtilityServiceType);
            
          
        }
      }
    }else{
      this.flatDataSec4['ManufacturedHousingUtility']=[];
      this.flatDataSetSec4['ManufacturedHousingUtility']=[];
    }
    
    //console.log(this.flatDataSec4);
    //console.log(this.flatDataSetSec4);

  }
  toTotalTabledata(){
    let range=this.pcaOp.reserve;
    let data={'cols':[],'rows':[]};
    let row=[];
    for(let i=0; i<range+1; i++){
      if(i==0){
        let item= {'INTERNALNAME':"col"+i,'KEY':"",'NAME':"",'TYPE':"text",'celAllign':"Left",'colAlign':"Left",'dir':"default",'unit':"%",'width':10, 'bk':'none', 'border':'none'};
        data.cols.push(item)
        let item1={'COLUMNINTERNALNAME': "col"+i, 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal'}
        row.push(item1)
      }else{
        let widthvalue=Math.floor(90/range); 
        let item= {'INTERNALNAME':"col"+i,'KEY':"",'NAME':"Year "+i,'TYPE':"text",'celAllign':"Center",'colAlign':"Center",'dir':"default",'unit':"%",'width':widthvalue, 'bk':'frm-blackcell', 'border':'1px solid black'};
        data.cols.push(item)
        let item1={'COLUMNINTERNALNAME': "col"+i, 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'};
        row.push(item1)
      }
    }
    let rowtitle=['Total (uninflated)','Inflation factor @ 3%','Total inflated'];
    for(let i=0; i<3; i++){
      let item=JSON.parse(JSON.stringify(row));
      item[0].data=rowtitle[i];
      item[0].border='none'
      if(i==1){
        for(let j=0; j<range; j++){
          if(j==0){
            item[j+1].KEY=100;
            item[j+1].data=item[j+1].KEY.toFixed(2)+"%"
          }else{
            item[j+1].KEY=this.getRound(item[j].KEY*(1+0.03));
            item[j+1].data=item[j+1].KEY.toFixed(2)+"%"
          }
          
        }
      }else{
        for(let j=0; j<range; j++){
          if(j>0){
            item[j]['sign']='$'; 
          }
                   
        }
      }
      data.rows.push(item);
    }
    
    this.sec6tablesdata.push(data);
    let data1={'cols':[],'rows':[]};
    let data2={'cols':[],'rows':[]};
    let row1=[];
    for(let i=0; i<2; i++){
      let item1={'COLUMNINTERNALNAME': "col"+i, 'data': '', 'KEY': '', 'width':'25', 'unit':'%', 'border':'1px solid black', 'celAllign':'Center'};
      if(i==0){
        item1.border='none';
        item1.celAllign='Left';
        item1.width='75';
      }else{
        item1['sign']='$';
      }
      row1.push(item1)      
    }
    let rowtitle1=['Total expenditures (uninflated)','Total expenditures (inflated)'];
    let rowtitle2=['Total expenditures per unit per year (uninflated)','Total expenditures per unit per year (inflated)'];
    for(let i=0; i<2; i++){
      let item=JSON.parse(JSON.stringify(row1));
      item[0].data=rowtitle1[i];
      data1.rows.push(item);
    }
    this.sec6tablesdata.push(data1);
    for(let i=0; i<2; i++){
      let item=JSON.parse(JSON.stringify(row1));
      item[0].data=rowtitle2[i];
      data2.rows.push(item);
    }
    this.sec6tablesdata.push(data2);
   // this.frmData['sec6tablesdata']=this.sec6tablesdata;
    //this.frmOutput.emit(this.frmData);
  }
  getRound(val, type?){
    let data=0;
		if(this.pcaOp.round=='Round'){
			if(type){
				data=Math.round(val*1000)/1000;
			}else if(this.pcaOp.decimal==2){
				data=Math.round(val*100)/100;
			}else if(this.pcaOp.decimal==0){
				data=Math.round(val);
			}
			
		}else if(this.pcaOp.round=='Round Up'){
			if(type){
				data=Math.ceil(val*1000)/1000;
			}else if(this.pcaOp.decimal==2){
				data=Math.ceil(val*100)/100;
			}else if(this.pcaOp.decimal==0){
				data=Math.ceil(val);
			}
			
		}else if(this.pcaOp.round=='Round Down'){
			if(type){
				data=Math.floor(val*1000)/1000;
			}else if(this.pcaOp.decimal==2){
				data=Math.floor(val*100)/100;
			}else if(this.pcaOp.decimal==0){
				data=Math.floor(val);
			}
			
		}
		
		return data;
	}
  getRound1(val, decimal, type?){//console.log(val, decimal, type)
    let data=0;
		if(this.pcaOp.round=='Round'){
			if(type){
				data=Math.round(val*1000)/1000;
			}else if(decimal==2){
				data=Math.round(val*100)/100;
			}else if(decimal==1){
				data=Math.round(val*10)/10;
			}else if(decimal==0){
				data=Math.round(val);
			}
			
		}else if(this.pcaOp.round=='Round Up'){
			if(type){
				data=Math.ceil(val*1000)/1000;
			}else if(decimal==2){
				data=Math.ceil(val*100)/100;
			}else if(decimal==1){
				data=Math.ceil(val*10)/10;
			}else if(decimal==0){
				data=Math.ceil(val);
			}
			
		}else if(this.pcaOp.round=='Round Down'){
			if(type){
				data=Math.floor(val*1000)/1000;
			}else if(decimal==2){
				data=Math.floor(val*100)/100;
			}else if(decimal==1){
				data=Math.floor(val*10)/10;
			}else if(decimal==0){
				data=Math.floor(val);
			}
			
		}
		//console.log(data)
		return data;
	}
  changetest(e){
		
    this.toOutput();
	}
  noCheckCat=['lastInspectionDate','unitCapacityAmps'];
  addDescription(e, category, type){//console.log(category, type)
    if(type=="unitCapacityAmps"){
      let val=e.target.value;
      if(val<0){
        e.target.value=0;
      }else if(val>999){
        e.target.value=999;
      }
    }
    let group=this.PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials;//console.log(group);
    let index=group.findIndex(data=>data.CatType==category&&data.ItemType==type);//console.log(index)
    let index1=this.flatData.indexOf(category+';'+type);//console.log(index1)
   //console.log(e.target.value.trim())
   //console.log(this.noCheckCat.indexOf(type)>-1)
      if(index>-1){
        group[index]["OtherItemDescription"]=e.target.value.trim();
      if(type=="lastInspectionDate"){
        let val=e.target.value;
        let date=this.datePipe.transform(val,"MM/dd/yy");
        group[index]["OtherItemDescription"]=date;
      }
        if(e.target.value.trim().length==0&&this.noCheckCat.indexOf(type)>-1){//console.log('remove')
          group.splice(index, 1); 
          this.flatData.splice(index1, 1)             
        } 
      }else if(e.target.value.trim().length>0&&this.noCheckCat.indexOf(type)>-1){//console.log('other')
        let item={
          "CatType": category,
          "ItemType": type,
          "OtherItemDescription":e.target.value,
        };
        if(type=="lastInspectionDate"){
          let val=e.target.value;
          let date=this.datePipe.transform(val,"MM/dd/yy");
          item["OtherItemDescription"]=date;
        }
        group.push(item); 
        this.flatData.push(category+';'+type);
      } 
      this.toOutput();       
  }
  addBuildMaterials(e, category, type, CatSubtype?){
    //console.log(this.flatData)
    //console.log(e.target.checked)
    //flatData.mechanicalsHvac.indexOf('otherHeat')
    let group=this.PropertyConditionAssessment[0].PropertyConditionAssessmentBuildingAndMaterials;
    let index=group.findIndex(data=>data.CatType==category&&data.ItemType==type);
    let index1=-1;
    if(CatSubtype&&CatSubtype!="OtherItemDescription"){
      index1=this.flatData.indexOf(category+';'+CatSubtype+';'+type);
      index=group.findIndex(data=>data.CatType==category&&data.ItemType==type&&data.CatSubtype==CatSubtype);
    }else{
      index1=this.flatData.indexOf(category+';'+type);
    }
    if(e.target.checked){
      let item={
        "CatType": category,
        "ItemType": type,
      };
      if(CatSubtype){
        if(CatSubtype=="OtherItemDescription"){
          item["OtherItemDescription"]=$(e.target).siblings('input').val();
        }else{
          item['CatSubtype']=CatSubtype;
        }
        
      }
      if(index==-1){
        group.push(item); 
      }
      if(index1==-1){
        if(CatSubtype&&CatSubtype!="OtherItemDescription"){
          this.flatData.push(category+';'+CatSubtype+';'+type);
        }else{
          this.flatData.push(category+';'+type);
        }        
      }
      
    }else{
      if(index>-1){
       /* let item=group[index];
        if(item.OtherItemDescription){
          $(e.target).siblings('input').val('');
        }*/
       group.splice(index, 1);
      }
      if(index1>-1){
        this.flatData.splice(index1, 1);
      }
    }
    
    this.toOutput();
  }
   noOther: string ;
  addAmentities(e, type){//console.log(e, type)
   // let index=this.PropertyAmenity.indexOf(type);console.log(index);
   let index1=this.PropertyAmenity.findIndex(data=>data.AmenityType&&data.AmenityType=='other');
   if(type=='OtherTypeDescription'){
   // let index=this.flatDataAmentities.findIndex(data=>data.e=='other');
   // let index1=this.PropertyAmenity.findIndex(data=>data.AmenityType&&data.AmenityType=='other');//console.log(index1);
    if(index1>-1){
      this.PropertyAmenity[index1]['OtherTypeDescription']=e.target.value
    }else{
      /*let item={
        "AmenityType": 'other',
        "OtherTypeDescription":e.target.value
      }
      this.PropertyAmenity.push(item);
      this.flatDataAmentities.push(item.AmenityType)*/
    }
  }else{
    //let index1=this.PropertyAmenity.findIndex(data=>data.AmenityType&&data.AmenityType=='other');
    let index=this.flatDataAmentities.indexOf(type);//console.log(index);
    if(e.target.checked){
      if(index==-1){
        let item={
          "AmenityType": type
        }
        if(type=='other'){
          item["OtherTypeDescription"]=$(e.target).siblings('input').val();
        }
        this.PropertyAmenity.push(item);
        this.flatDataAmentities.push(item.AmenityType)
      }
      
    }else{
      if(index>-1){
        //this.PropertyAmenity[index]["OtherTypeDescription"]='';
        this.PropertyAmenity.splice(index1, 1); 
        this.flatDataAmentities.splice(index, 1) 
      }      
    }
  }
  //console.log(this.flatDataAmentities)
 // console.log(this.PropertyAmenity)
    this.frmData.PropertyAmenity=this.PropertyAmenity;
    this.toOutput();
  }
  toOutput(){
    this.frmData['AccountNameHTML']=this.AccountNameHTML;
    this.flatToFrmdata();
    this.frmOutput.emit(this.frmData);
  }
  flatToFrmdata(){
    let alldata=this.PropertyConditionAssessment[0];
  
    alldata['PropertyConditionAssessmentWaterTreatment']=[];//alldata['PropertyConditionAssessmentWaterTreatment'].filter(item => item['PptyWaterSystemType']=='');
      for(let i=0; i<this.waters.length; i++){
        //if(this.flatPartySetSec3[this.waters[i]]){
        //  alldata.PropertyConditionAssessmentWaterTreatment.push(this.flatPartySetSec3[this.waters[i]])
        //}
        if(this.flatDataSetSec3[this.waters[i]]){
          alldata.PropertyConditionAssessmentWaterTreatment=[...alldata.PropertyConditionAssessmentWaterTreatment, ...this.flatDataSetSec3[this.waters[i]]];
        }
      }
      alldata['PropertyConditionAssessmentManufacturedHousing']=[]
      for(let item of this.flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing
        ){
        alldata['PropertyConditionAssessmentManufacturedHousing'].push(item)
      }  
 
  }
  validateInput(e, data, field, type?){
    let value=e.target.value;
    if(value&&parseInt(value)>-1){
      if(type){
				e.target.value=this.getRound1(value, 1);
			}else{
				e.target.value=this.getRound1(value, 0);
			}
    }else{
      e.target.value=0;
    }
    data[field]=e.target.value;
    this.frmOutput.emit(this.frmData);
  }
  addUnit1(e?, index?, field?){
    if(index>-1){
      let value=e.target.value;
      if(value&&parseInt(value)>-1){
        this.PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix[index][field]=parseInt(value);
      }else{
        this.PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix[index][field]=0;
      }
    }    
    //console.log(this.PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix)
    this.PropertyTotalRentRollSummary[0].TotalOccupiedUnitCount=0;
    this.PropertyTotalRentRollSummary[0].TotalVacantUnitCount=0;
    this.PropertyTotalRentRollSummary[0].PptyTotalDownUnitCount=0;
    this.PropertyTotalRentRollSummary[0].TotalOtherUnitCount=0;
    for(let row of this.PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix){
      this.PropertyTotalRentRollSummary[0].TotalOccupiedUnitCount+=row.PptyUnitTypeOccupiedUnitCount;
      this.PropertyTotalRentRollSummary[0].TotalVacantUnitCount+=row.VacantUnitCount;
      this.PropertyTotalRentRollSummary[0].PptyTotalDownUnitCount+=row.PptyUnitTypeDownUnitCount;
      this.PropertyTotalRentRollSummary[0].TotalOtherUnitCount+=row.PptyUnitTypeOtherUnitCount;
    }
    this.getTotalUnit();
    this.frmOutput.emit(this.frmData);
  }
  addUnit2(e?, index?, field?){
    if(index>-1){
      let value=e.target.value;
      if(value&&parseInt(value)>-1){
        this.PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix[index][field]=parseInt(value);
      }else{
        this.PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix[index][field]=0;
      }
    }  
    //console.log(this.PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix)
    this.PropertyConditionAssessment[0].RsdntlOccupiedInspectedUnitCount=0;
    this.PropertyConditionAssessment[0].RsdntlVacantInspectedUnitCount=0;
    this.PropertyConditionAssessment[0].RsdntlDownInspectedUnitCount=0;
    this.PropertyConditionAssessment[0].RsdntlOtherInspectedUnitCount=0;
    for(let row of this.PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix){
    this.PropertyConditionAssessment[0].RsdntlOccupiedInspectedUnitCount+=row.PptyUnitTypeOccupiedInspectedUnitCount;
    this.PropertyConditionAssessment[0].RsdntlVacantInspectedUnitCount+=row.PptyUnitTypeVacantInspectedUnitCount;
    this.PropertyConditionAssessment[0].RsdntlDownInspectedUnitCount+=row.PptyUnitTypeDownInspectedUnitCount;
    this.PropertyConditionAssessment[0].RsdntlOtherInspectedUnitCount+=row.PptyUnitTypeOtherInspectedUnitCount;
    }
    this.getTotalUnit();
    this.frmOutput.emit(this.frmData);
  }
  addUnit3(index,e?, field?){
    if(index>-1){
      let value=e.target.value;
      if(value&&parseInt(value)>-1){
        this.PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix[index][field]=parseInt(value);
      }else{
        this.PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix[index][field]=0;
      }
    }
    //console.log(this.PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix[0])
    let item=this.PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix[index];
    item.UnitCount=item.OccupiedUnitCount+item.VacantUnitCount+item.DownUnitCount;
    this.getTotalUnit();
    this.frmOutput.emit(this.frmData);
  }
  getTotalUnit(){
    let item1=this.PropertyTotalRentRollSummary[0];
    //let item2=this.PropertyConditionAssessment[0];
    let item3=item1.PropertyCommercialUsageMix;
    item1.PropertyResidentialRentRollSummary[0].RsdntlTotalUnitCount=item1.TotalOccupiedUnitCount+item1.TotalVacantUnitCount+item1.PptyTotalDownUnitCount+item1.TotalOtherUnitCount;//+item2.RsdntlOccupiedInspectedUnitCount+item2.RsdntlVacantInspectedUnitCount+item2.RsdntlDownInspectedUnitCount+item2.RsdntlOtherInspectedUnitCount;
    item1.PropertyCommercialRentRollSummary[0].CommercialTotalUnitCount=item3[0].UnitCount+item3[1].UnitCount;
    item1.TotalUnitCount=item1.PropertyResidentialRentRollSummary[0].RsdntlTotalUnitCount+item1.PropertyCommercialRentRollSummary[0].CommercialTotalUnitCount
  }
  saveChange(){
    this.frmOutput.emit(this.frmData);
  }
  setCost(row, cell, e){
    let val= parseInt(e.target.value);
    if(val>-1){
      let item=this.costTables[val];
      cell['costtable']=item.id;
      cell['costlabel']=item.pre.SECTION_SEQUENCE+' '+item.pre.SECTION_TITLE;
    }else{
      delete cell['costtable'];
      delete cell['costlabel'];
    }
    
    this.frmData['sec2tablesdata']=this.sec2tablesdata;
    this.frmOutput.emit(this.frmData);
    if(this.src=='rpt'){
      this.costItem.emit(cell);
    }
  }
  public AccountNameHTML={'data':'','html':'', 'secHtml':null, 'addedItem':null,'text':'', };
  openPara(e, field){
     if(e && e.target){
			e.stopPropagation();
      //e.preventDefault();
		}
    //this.AccountNameHTML.data=this.PropertyAsReported[0].AccountName;{'html':'<p></p>','data':'', 'secHtml':null, 'addedItem':null}
    if(!field){
      field={'html':'<p></p>','data':'', 'text':'', 'secHtml':null, 'addedItem':null};
    }
    this.toRF.emit(field);
  }
  toUL(){
    for(let j=0; j<this.sec2tablesdata.length;j++){
      let rows=this.sec2tablesdata[j].rows;
        for(let i=0; i<rows.length; i++){
          if(rows[i][0]['costtable']){
            let index=this.costTables.findIndex(cost=>cost.id==rows[i][0]['costtable']);
            if(index>-1){
              rows[i][0].costlabel=this.costTables[index].pre.SECTION_SEQUENCE+' '+this.costTables[index].pre.SECTION_TITLE;; 
            }
          }                     
        }
    }
    
    this.frmData['sec2tablesdata']=this.sec2tablesdata;
    this.frmOutput.emit(this.frmData);
  }
  toSanitizer(){
    if(this.PropertyAsReportedHTML){
      let items=[this.PropertyAsReportedHTML,this.PropertyConditionAssessmentHTML, this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML];
      for(let item of items){
        let keys=Object.keys(item);
        for(let key of keys){
          if(!item[key].secHtml&&item[key].html){
            item[key].secHtml=this.sanitizer.bypassSecurityTrustHtml(item[key].html);
          }
        }
        
      }
      
    }

  }
  repairtCount=[false,false,false,false,false, false]
  addToJson(costItems){
    let tableJson=this.PropertyConditionAssessment[0]['PropertyConditionAssessmentItem'];
    let table2Json=this.PropertyConditionAssessment[0]['PropertyRepair'];  
    //let table6Json=this.PropertyConditionAssessment['PropertyCapitalExpenditureProjection']
   // let table3Json=this.PropertyConditionAssessment['AssessmentItemCapitalExpenditureProjectionDetails']
    let categories=this.tableset.sec2tables.CatType;
    let item={
      //"ItemType":costItems['Item'],
      "CatType": costItems['cat'],
      //"CatSubtype": "Flooring",
      "EstUsefulLifeYrCountRangeValue":costItems['EUL'],
      "RatingType":costItems['condition'],
      "RemainingUsefulLifeYrRangeValue":costItems['RUL'],
      "RepairPriorityType":"",//costItems['ACTION'],
      "CommentText":costItems['MOComm']
      };
      if(costItems['RULtext']){
        item.RemainingUsefulLifeYrRangeValue=costItems['RULtext'];
      }
      let actions="";
      if(costItems['ACTION'].length>0){
        actions=costItems['ACTION'][0].name;
        for(let i=1; i<costItems['ACTION'].length; i++){
          actions+=', '+ costItems['ACTION'][i].name;
        }
      }
      
      item.RepairPriorityType=actions;
      if(costItems['parent']){        
        item["CatSubtype"]=costItems['parent'];    
        if(costItems['describe']){
          let val=costItems['Item'];
          item["ItemType"]=val.replace('describe', costItems['describeInput'])
        }else if(costItems['other']&&costItems['otherInput']){
          item["ItemType"]='Other';//costItems['otherInput'];
        }else{
          item["ItemType"]=costItems['Item'];
        }     
      }else{
        item["ItemType"]=costItems['Item'];     
      }
      let index=categories.indexOf(item.CatType);
      //if(!this.repairtCount[index]){
      //  this.repairtCount[index]=true
      //}
      if(costItems['Quantity']){
        item["ItemCount"]=costItems['Quantity'];
        item["UnitOfMeasureType"]=costItems['Unit'];
        item["CapitalExpenditurePerUnitOfMeasureCostAmt"]=costItems['Cost'];
        item["TotalCapitalExpenditureAmt"]=costItems['Reserve']-costItems['reserve'];
      }
      if(costItems.selectedYear.length>0) {
        item["AssessmentItemCapitalExpenditureProjectionDetails"]=[];
        for(let year of costItems.selectedYear){
          let yearItem={
            "PptyItemProjectedYrCapitalExpenditureAmt": costItems.allocate[year-1],
            "YrNumber": year,
            }
            item["AssessmentItemCapitalExpenditureProjectionDetails"].push(yearItem)
        }
      }
      tableJson.push(item) 
      if(costItems['CRCHK']){
          let repairItem={
            "PptyCatType": costItems['cat'],
            "ItemType": costItems['Item'],
            "PriorityType": "CR",
            "UnitOfMeasureType": costItems['Unit'],
            "ItemCount": costItems['Quantity'],
            "PerItemCostAmt": costItems['Cost'],
            "EstCostAmt": costItems['CR'],
            "CommentText": costItems['CRBP']
            };
            table2Json.push(repairItem);
      }
      if(costItems['PRCHK']){
        let repairItem={
          "PptyCatType": costItems['cat'],
          "ItemType": costItems['Item'],
          "PriorityType": "PR",
          "UnitOfMeasureType": costItems['Unit'],
          "ItemCount": costItems['Quantity'],
          "PerItemCostAmt": costItems['Cost'],
          "EstCostAmt": costItems['PR'],
          "CommentText": costItems['PRBP']
          };
          table2Json.push(repairItem);
      }
      if( costItems['PR90CHK']){
        let repairItem={
          "PptyCatType": costItems['cat'],
          "ItemType": costItems['Item'],
          "PriorityType": "PR-90",
          "UnitOfMeasureType": costItems['Unit'],
          "ItemCount": costItems['Quantity'],
          "PerItemCostAmt": costItems['Cost'],
          "EstCostAmt": costItems['PR90'],
          "CommentText": costItems['PR90BP']
          };
          table2Json.push(repairItem);
      }
      if( costItems['ORCHK']){
        let repairItem={
          "PriorityType": "OR",
          "CommentText": costItems['ORBP']
        }
        table2Json.push(repairItem);
       // if(!this.repairtCount[4]){
        //  this.repairtCount[4]=true
       // }
      }
      //this.frmData['repairtCount']= this.repairtCount;
      
  }
  getLastIndex(table, rowItem){
    let arr=[];
    for(let i=0; i<table.rows.length; i++){
      if(table.rows[i][0]['parent']==rowItem['parent']){
        arr.push(i)
      }
    }
      
      return arr[arr.length - 1]
  }
  toFrmTable(){   
    this.PropertyConditionAssessment[0]['PropertyConditionAssessmentItem']=[];
    this.PropertyConditionAssessment[0]['PropertyRepair']=[];
    this.PropertyConditionAssessment[0]['PropertyCapitalExpenditureProjection']=[];
    this.ORrows=[];
    this.repairTotal=0;
    //this.repairtCount=[false,false,false,false,false, false]
    for(let table6 of this.sec6tablesdata.slice(0,4)){
      if(table6.cols[4].NAME=='Year X'){
        table6=this.replaceYear(table6);
      }
      for(let row of table6.rows){
        for(let i=1; i<row.length; i++){
          row[i].data='';
        }
      }
      table6.rows=table6.rows.filter(row => !row[0]['addedother']);  
    }
    
    for(let j=0; j<this.sec6tablesdata[4].rows.length; j++){
      if(j!=1){
        for(let i=1; i<this.sec6tablesdata[4].rows[j].length; i++){
          this.sec6tablesdata[4].rows[j][i].data=0;
      }
      }
      
    }
    for(let row of this.sec6tablesdata[5].rows){
      row[1].data=0;
    }
    for(let row of this.sec6tablesdata[6].rows){
      row[1].data=0;
    }
    for(let table3 of this.sec3tablesdata){
      table3.rows=[];
    }
    for(let table2 of this.sec2tablesdata){
      if(this.costTables.length>0){
        table2.rows=table2.rows.filter(row => !row[0]['addedother']);
          for(let row of table2.rows){
          if(row[0].costtable){
            delete row[0]['costtable'];
            delete row[0]['costlabel'];
          }
          for(let i=1; i<row.length; i++){
            row[i].data='';
          }
        }
        
      }
      
    }
    let categories=this.tableset.sec2tables.CatType;
    let allAllocate=[];
    let uninflateddata=[];
    let table3Total=[0,0,0,0];
    let table3Chk=[false,false,false,false]
    for(let costtable of this.costTables){
      if(costtable.data.COST&&costtable.data.COST.length>0){
        let index=categories.indexOf(costtable.cat);
        if(index>-1){
          let table2=this.sec2tablesdata[index];
          let table3=this.sec3tablesdata[index];
          //table3.rows=[];
          let baserow3=this.tableset.sec3tables.baserow;
          table3Chk[index]=true;
          let table6=this.sec6tablesdata[index];
          for(let costitems of costtable.data.COST){
            this.addToJson(costitems);
            let index1=-1;
            if(costitems.parent){
              if(costitems['describe']){
                index1=table2.rows.findIndex(row=>row[0].data==costitems.Item&&row[0].parent==costitems.parent);
                if(index1==-1){
                  index1=table2.rows.findIndex(row=>row[0]['oridata']==costitems.Item&&row[0].parent==costitems.parent);
                }
              }else if(costitems['other']){
                index1=table2.rows.findIndex(row=>row[0].data==costitems.otherInput&&row[0].parent==costitems.parent);
              }else{
                index1=table2.rows.findIndex(row=>row[0].data==costitems.Item&&row[0].parent==costitems.parent);
              }
              
            }else{
              index1=table2.rows.findIndex(row=>row[0].data==costitems.Item&&(!row[0].parent));
            }
            let row:any;
            if(index1>-1){
              row=table2.rows[index1];//console.log(row)
              if(costitems['describe']){
                let val=costitems.Item;
                row[0]['oridata']=val;
                row[0].data=val.replace('describe', costitems['describeInput']);               
              }     
            }else{
              row=JSON.parse(JSON.stringify(this.tableset.sec2tables.baserow));
              row[0].data=costitems.Item
              if(costitems['other']){
                row[0].data=costitems['otherInput']; 
                row[0]['sub']='20px';
                row[0]['parent']= costitems['parent'];
                //row[0]['addedother']= true;
              }  
              row[0]['addedother']= true;
            }
            let action="";
            if(costitems.ACTION&&costitems.ACTION.length>0){
              action=costitems['ACTION'][0].name;
              for(let i=1; i<costitems['ACTION'].length; i++){
                action+=', '+ costitems['ACTION'][i].name;
              }              
            }
            if(!row[0]['costtable']){
              row[0]['costtable']=costtable.id;
              row[0]['costtables']=[costtable.id];
              row[0]['costlabel']=costtable.pre.SECTION_SEQUENCE+' '+costtable.pre.SECTION_TITLE;
            }else{
              row[0]['costtables'].push(costtable.id);
            }
                
                
                if(costitems.RULtext){
                  row[3].data=costitems.RULtext;
                }else if(costitems.RUL==0){
                  row[3].data="";
                }else{
                  row[3].data=costitems.RUL;
                }     
                if(costitems.EUL==0){
                  row[1].data="";                  
                }else{
                  row[1].data=costitems.EUL;
                }   
              
                if(costitems.condition.length>0){
                  row[2].data=costitems.condition;
                }    
                if(row[4].data.length>0){
                  if(action.length>0){
                    row[4].data=row[4].data + ", " + action;
                  }                  
                }else{
                  row[4].data=action;
                }
                if(costitems.MOComm&&costitems.MOComm.trim().length>0){
                  if(row[5].data&&row[5].data.length>0){
                    row[5].data=row[5].data + "\n" + costitems.MOComm;
                  }else{
                    row[5].data=costitems.MOComm;
                  }                 
                }
              //console.log(row)
              if(index1==-1){
                if(costitems['other']){
                  let lastIndex=this.getLastIndex(table2, costitems);
                  table2.rows.splice(lastIndex+1, 0, row );
                }else{
                  table2.rows.push(row);
                }
                
              }
              if(costitems.CRCHK){
                let row1=JSON.parse(JSON.stringify(baserow3));
                row1[0].data=costitems.Item;
                if(costitems['describe']){
                  let val=costitems.Item;
                  row1[0].data=val.replace('describe', costitems['describeInput']);               
                }else if(costitems['other']){
                  row1[0].data=costitems['otherInput'];
                  row[0]['parent']= costitems['parent']; 
                  row[0]['addedother']= true; 
                                    
                }   
                row1[1].data="CR";
                row1[2].data=costitems.Unit;
                if(costitems.CRQuantity && costitems.CRQuantity.trim().length>0){
                  row1[3].data=parseInt(costitems.CRQuantity);
                }else{
                  row1[3].data=costitems.Quantity;
                }
                
                row1[4].data=costitems.Cost;
                row1[5].data=costitems.CR;
                row1[6].data=costitems.CRBP;
                table3Total[index]+=costitems.CR;
                table3.rows.push(row1);
              }
              if(costitems.PRCHK){
                let row2=JSON.parse(JSON.stringify(baserow3));
                row2[0].data=costitems.Item;
                if(costitems['describe']){
                  let val=costitems.Item;
                  row2[0].data=val.replace('describe', costitems['describeInput']);               
                }else if(costitems['other']){
                  row2[0].data=costitems['otherInput']; 
                  row[0]['parent']= costitems['parent'];   
                  row[0]['addedother']= true;                
                } 
                row2[1].data="PR";
                row2[2].data=costitems.Unit;
                if(costitems.PRQuantity && costitems.PRQuantity.trim().length>0){
                  row2[3].data=parseInt(costitems.PRQuantity);
                }else{
                  row2[3].data=costitems.Quantity;
                }                
                row2[4].data=costitems.Cost;
                row2[5].data=costitems.PR;
                row2[6].data=costitems.PRBP;
                table3Total[index]+=costitems.PR;
                table3.rows.push(row2);
              }
              if(costitems.PR90CHK){
                let row3=JSON.parse(JSON.stringify(baserow3));
                row3[0].data=costitems.Item;
                if(costitems['describe']){
                  let val=costitems.Item;
                  row3[0].data=val.replace('describe', costitems['describeInput']);               
                }else if(costitems['other']){
                  row3[0].data=costitems['otherInput'];
                  row[0]['parent']= costitems['parent'];  
                  row[0]['addedother']= true;                  
                } 
                row3[1].data="PR-90";
                row3[2].data=costitems.Unit;
                if(costitems.PR90Quantity && costitems.PR90Quantity.trim().length>0){
                  row3[3].data=parseInt(costitems.PR90Quantity);
                }else{
                  row3[3].data=costitems.Quantity;
                }
                row3[4].data=costitems.Cost;
                row3[5].data=costitems.PR90;
                row3[6].data=costitems.PR90BP;
                table3Total[index]+=costitems.PR90;
                table3.rows.push(row3);
              }
              
              if(costitems.ORCHK){
                this.ORrows.push(costitems.ORBP)
              }
              
            //}
            
            let index6=-1;//table6.rows.findIndex(row=>row[0].data==costitems.Item);
            if(costitems.parent){
              if(costitems['describe']){
                index6=table6.rows.findIndex(row=>row[0].data==costitems.Item&&row[0].parent==costitems.parent);
                if(index6==-1){
                  index6=table6.rows.findIndex(row=>row[0]['oridata']==costitems.Item&&row[0].parent==costitems.parent);
                }
              }else if(costitems['other']){
                index6=table6.rows.findIndex(row=>row[0].data==costitems.otherInput&&row[0].parent==costitems.parent);
              }else{
                index6=table6.rows.findIndex(row=>row[0].data==costitems.Item&&row[0].parent==costitems.parent);
              }
              
            }else{
              index6=table6.rows.findIndex(row=>row[0].data==costitems.Item);
            }
            if(index6>-1){
              let itemkeys=this.table6Itemkeys[index];
              let row=table6.rows[index6];
              if(costitems['describe']){
                let val=costitems.Item;
                row[0]['oridata']=val;
                row[0].data=val.replace('describe', costitems['describeInput']);               
              }  
             // if(row[0].costtable==costitems.id){
              if(costitems.selectedYear.length>0){
                if(costitems.RRQuantity && costitems.RRQuantity.trim().length>0){
                  row[1].data=parseInt(costitems.RRQuantity);
                }else{
                  row[1].data=costitems.Quantity;
                }  
                //row[1].data=costitems.Quantity;
                row[2].data=costitems.Unit;
                row[3].data=costitems.Cost;
               for(let i=0; i<costitems.allocate.length; i++){
                if(costitems.selectedYear.indexOf(i+1)>-1){
                  if(costitems.allocate[i]>0){
                    row[i+4].data=costitems.allocate[i].toString();
                  }else{
                    row[i+4].data='0';
                  }
                }else{
                  row[i+4].data='';
                }
                
                
               }
               
               row[row.length-1].data=(costitems.Reserve-costitems.reserve).toString();
              }else{
                
                  /*for(let i=4; i<row.length; i++){
                    row[i].data='';
                  }*/
               
              }

            }else{
              if((costitems['actions']&&costitems['actions'].indexOf('RR')>-1)||costitems['selectedYear'].length>0){
              let row=JSON.parse(JSON.stringify(table6.rows[0]));
                row[0].data=costitems.Item;
                if(costitems['other']){
                    row[0].data=costitems['otherInput']; 
                    row[0]['sub']='20px';
                    row[0]['parent']= costitems['parent']; 
                    //row[0]['addedother']= true;   
                } 
                row[0]['addedother']= true;  
                row[1].data=costitems.Quantity;
                //not sure if this should behind if(costitems.selectedYear.length>0)
               if(costitems.RRQuantity && costitems.RRQuantity.trim().length>0){
                  row[1].data=parseInt(costitems.RRQuantity);
                }else{
                  row[1].data=costitems.Quantity;
                }
                row[2].data=costitems.Unit;
                row[3].data=costitems.Cost;
                if(costitems.selectedYear.length>0){            
                  for(let i=0; i<costitems.allocate.length; i++){
                    if(costitems.selectedYear.indexOf(i+1)>-1){
                      if(costitems.allocate[i]>0){
                        row[i+4].data=costitems.allocate[i].toString();
                      }else{
                        row[i+4].data='0';
                      }
                    }else{
                      row[i+4].data='';
                    }
                    
                    
                  }
                  row[row.length-1].data=(costitems.Reserve-costitems.reserve).toString();
                }else{
                  for(let i=4; i<row.length; i++){
                    row[i].data='';
                  }
                }
               //if(index6==-1){
                if(costitems['other']){
                  let lastIndex=this.getLastIndex(table6, costitems);
                  table6.rows.splice(lastIndex+1, 0, row );
                }else{
                  table6.rows.push(row);
                }
                
              //}
            }
               
            }
            allAllocate.push(costitems.allocate)
          }
          //let table6=this.sec2tablesdata[index];
        }
        
        //Item=="Maintenance structures"
        //cat==site"
      }
      
      
      
    }
    for(let i=0; i<table3Chk.length; i++){
      let totalrow3=this.tableset.sec3tables.totalrow;
      let row=JSON.parse(JSON.stringify(totalrow3));
      if(table3Chk[i]){
        row[1].data=this.getRound1(table3Total[i], 2);
        this.sec3tablesdata[i].rows.push(row);
        this.repairTotal+=table3Total[i];
      }     
    }
    this.repairTotal=this.getRound1(this.repairTotal,2)
    //console.log(allAllocate)
    for(let item of allAllocate){
      for(let i=0; i<item.length; i++){
        if(!uninflateddata[i]){
          uninflateddata[i]=item[i]
        }else{
          uninflateddata[i]+=item[i]
        }
      }
    }
   
      let row1=this.sec6tablesdata[4].rows[0];
      let row2=this.sec6tablesdata[4].rows[1];
      let row3=this.sec6tablesdata[4].rows[2];
      let totalUninflated=0;
      let totalInflated=0;
      for(let i=0; i<uninflateddata.length; i++){
        row1[i+1].data=this.getRound(uninflateddata[i]);
        row2[i+1].data=row2[i+1].KEY.toFixed(2)+'%';
        row3[i+1].data=this.getRound(uninflateddata[i]*row2[i+1].KEY/100);
        totalUninflated+=this.getRound(uninflateddata[i]);
        totalInflated+=this.getRound(row3[i+1].data);
      }
      let row4=this.sec6tablesdata[5].rows;
      let row5=this.sec6tablesdata[6].rows;
      row4[0][1].data=this.getRound(totalUninflated);
      row4[1][1].data=this.getRound(totalInflated);
      if(this.pcaOp.reserve==0||this.pcaOp.quantity==0){
        row5[0][1].data=0;
        row5[1][1].data=0;
      }else{
        row5[0][1].data=this.getRound(totalUninflated/this.pcaOp.reserve/this.pcaOp.quantity);     
        row5[1][1].data=this.getRound(totalInflated/this.pcaOp.reserve/this.pcaOp.quantity);
      }
      this.PropertyConditionAssessment[0]['CapitalExpenditureTotalLoanTermInflatedAmt']=row4[1][1].data
      this.PropertyConditionAssessment[0]['CapitalExpenditureTotalLoanTermUninflatedAmt']=row4[0][1].data
      this.PropertyConditionAssessment[0]['CapitalExpenditureUnitAnnualInflatedAmt']=row5[1][1].data
      this.PropertyConditionAssessment[0]['CapitalExpenditureUnitAnnualUninflatedAmt']=row5[0][1].data
    //console.log(uninflateddata);
   /* let action=''
    for(let ac of item.ACTION){
      action +=ac.name+', ';
    }
    for(let table of this.sec2tablesdata){
      for(let row of table.rows){
        if(row[0].costtable==item.id){
          row[1].data=item.EUL;
          row[2].data=item.RUL;
          row[3].data=item.CONDITION;
          row[4].data=action;
        }
      }
    }*/
    for(let i=0; i<row1.length; i++){
      //if(row1[i].data>0){
        let item={
          "YrNumber": i,
          "TotalUninflatedAmt": row1[i].data,
           "InflationFactorPct": this.getRound(row2[i].KEY*100)/100,
           "TotalInflatedAmt": row3[i].data,
        }
        this.PropertyConditionAssessment[0]['PropertyCapitalExpenditureProjection'].push(item);
     // }
    }
    this.frmData['sec2tablesdata']=this.sec2tablesdata;
    this.frmData['sec3tablesdata']=this.sec3tablesdata;
    this.frmData['sec6tablesdata']=this.sec6tablesdata;
    this.frmData['repairTotal']=this.repairTotal;
    this.frmData['ORrows']=this.ORrows;
    this.frmOutput.emit(this.frmData);
  }
  replaceYear(table){
   // let col=JSON.parse(JSON.stringify(table.cols[4]));
    let lastcol=JSON.parse(JSON.stringify(table.cols[5]));    
    table.cols=table.cols.slice(0, -2);
    for(let i=0; i<this.pcaOp.reserve; i++){//console.log(i)
      let colName='col'+(4+i);
      let yearName="Year "+(i+1);
      let item= {'INTERNALNAME':colName,'KEY':"",'NAME':yearName,'TYPE':"text",'celAllign':"Center",'colAlign':"Center",'dir':"default",'unit':"%",'width':4.5, 'bk':'frm-graycell', 'border':'1px solid black','sign':'$'};
      if(i>2){
        item['hide']=true;
      }
      table.cols.push(item)
    }    
    lastcol.INTERNALNAME='col'+(4+this.pcaOp.reserve);
    lastcol.width=9;
    table.cols.push(lastcol);
    //console.log(table.cols.length)
    let allcol=table.cols.length;//console.log(allcol)
    let rows=[]
    for(let row of table.rows){
      row=row.slice(0, -2);
      let baseitem={'COLUMNINTERNALNAME': '', 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black','sign':'$'};
      for(let i=4; i<allcol; i++){//console.log(i)
        let cell=JSON.parse(JSON.stringify(baseitem));  
        cell.COLUMNINTERNALNAME=table.cols[i].INTERNALNAME;
        if(i==allcol-1){
          cell.bk='frm-graycell';
        }
        row.push(cell)
      }
      //console.log(JSON.stringify(row))
      rows.push(row)
    }
    //console.log(table)
    table.rows=rows;
    return table
  }
  USDollar = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		//trailingZeroDisplay: 'stripIfInteger',
	});
  curUnit={
    "BedroomCount": 0,
    "BathroomCount": 0,
    "AvgSquareFeetNumber": 0,
    "StyleType": "",
    "PptyUnitTypeOccupiedUnitCount": 0,
    "VacantUnitCount": 0,
    "PptyUnitTypeDownUnitCount": 0,
    "PptyUnitTypeOtherUnitCount": 0,
    "PptyUnitTypeOccupiedInspectedUnitCount": 0,
    "PptyUnitTypeVacantInspectedUnitCount": 0,
    "PptyUnitTypeDownInspectedUnitCount": 0,
    "PptyUnitTypeOtherInspectedUnitCount": 0
    };
  insertUnit(e){
    if(e && e.target){
			e.stopPropagation();
		}
    let group=this.PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix; 
    let newUnit=JSON.parse(JSON.stringify(this.curUnit))
    group.push(newUnit);
    this.frmOutput.emit(this.frmData);
  }
  deleteUnit(e){
    if(e && e.target){
			e.stopPropagation();
		}
    Swal.fire({
			icon:'warning',
			title: 'This will erase the last line. Is this what you want to do?',
			confirmButtonText: 'Yes',
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
      let group=this.PropertyTotalRentRollSummary[0].PropertyResidentialUnitMix; 
      group.pop();
      this.addUnit1();
      this.addUnit2();
      this.getTotalUnit();
      this.frmOutput.emit(this.frmData);
    }
  })
  }
  addUnitId(e, rowIndex, colindex, field){
    let val=e.target.value.trim();
    let index=4*rowIndex+colindex;
    if(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index]==''||this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index]){      
      this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index][field]=val;
    }else{
      let item={
        "UnitType": "",
        "SlrDesignatedUnitId": "",
        "OccupancyStatusType": ""
        }
        item[field]=val;
      this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index]=item;
    }
    this.frmOutput.emit(this.frmData);
  }
  addStaus(val, rowIndex, colindex, field,e){
    if(e && e.target){
			e.stopPropagation();
      //e.preventDefault();
		}
    let index=4*rowIndex+colindex;
    let status=Array.from(val)[0]; 
    if(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index]==""||this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index]){      
      this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index][field]=status;
    }else{
      let item={
        "UnitType": "",
        "SlrDesignatedUnitId": "",
        "OccupancyStatusType": ""
        }
        item[field]=status;
      this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index]=item;
    }
    this.frmOutput.emit(this.frmData);
  }
  addStaus1(e, rowIndex, colindex, field){
    if(e && e.target){
			e.stopPropagation();
      //e.preventDefault();
		}
    let index=4*rowIndex+colindex;
    let val=e.target.value.trim();
    let status=Array.from(val)[0]; 
    if(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index]==""||this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index]){      
      this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index][field]=status;
    }else{
      let item={
        "UnitType": "",
        "SlrDesignatedUnitId": "",
        "OccupancyStatusType": ""
        }
        item[field]=status;
      this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index]=item;
    }
    this.frmOutput.emit(this.frmData);
  }
  addBedroomType(val, rowIndex, colindex,  field, e){
    if(e && e.target){
			e.stopPropagation();
		}
    let index=4*rowIndex+colindex;
    if(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index]==''||this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index]){
     this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index][field]=val;
    }else{
      let item={
        "UnitType": "",
        "SlrDesignatedUnitId": "",
        "OccupancyStatusType": ""
        }
        item[field]=val;
      this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index]=item;
    }
    this.frmOutput.emit(this.frmData);
  }
  addBedroomType1(e, rowIndex, colindex,  field){
    if(e && e.target){
			e.stopPropagation();
      //e.preventDefault();
		}
    let index=4*rowIndex+colindex;
    let val=e.target.value.trim();
    if(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index]==''||this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index]){
     this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index][field]=val;
    }else{
      let item={
        "UnitType": "",
        "SlrDesignatedUnitId": "",
        "OccupancyStatusType": ""
        }
        item[field]=val;
      this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[index]=item;
    }
    this.frmOutput.emit(this.frmData);
  }
  insertRow(e){
    if(e && e.target){
			e.stopPropagation();
		}
    this.unitrow++;
    let item={
      "UnitType": "",
      "SlrDesignatedUnitId": "",
      "OccupancyStatusType": ""
      }
      for(let i=0; i<4; i++){
         this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.push(JSON.parse(JSON.stringify(item)));
      }   
    this.frmOutput.emit(this.frmData);
  }
  deleteRow(e){
    if(e && e.target){
			e.stopPropagation();
		}
    Swal.fire({
			icon:'warning',
			title: 'This will erase the last line. Is this what you want to do?',
			confirmButtonText: 'Yes',
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {      
      for(let i=(this.unitrow-1)*4+3; i>(this.unitrow-1)*4-1; i--){
        if(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit[i]){
          this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.splice(i, 1)
        }     
      }
      this.unitrow--;
      this.frmOutput.emit(this.frmData);
    }
  })
  
  }
  flatPartySetSec3={};
  setWaterSec(e, type){
   if(type!='none'){
      let index=this.waters.indexOf(type);
      if(e.target.checked){        
        if(type=='privateWellsDrinkingWater'){
          let item={"PptyWaterSystemType": "privateWellsDrinkingWater",
            "WaterSystemOperationsDescription": "",
            "WaterSystemToMunicipalSystemConnectionDescription": "",
            "WaterSystemMaintenanceResponsiblePartyType": "",
            "WaterSystemMaintenanceResponsiblePartyName": "",
            "WaterSystemMaintenancePartyQualificationsDescription": ""
          }
           this.flatPartySetSec3[type]=item;
           this.flatDataSec3[type]=[];
          this.flatDataSetSec3[type]=[]; 
        }else if(type=='wasteWaterTreatment'){
           let item={
            "PptyWaterSystemType": "wasteWaterTreatment",
            "WaterSystemOperationsDescription": "",
            "WastewaterLeachFieldDescription": "",
            "WastewaterEffluentDischargeDescription": "",
            "WaterSystemToMunicipalSystemConnectionDescription": "",
            "WaterSystemMaintenanceResponsiblePartyType": "",
            "WaterSystemMaintenanceResponsiblePartyName": "",
            "WaterSystemMaintenancePartyQualificationsDescription": ""
            }
            this.flatPartySetSec3[type]=item;
            this.flatDataSec3[type]=[];
            this.flatDataSetSec3[type]=[]; 
        //this.flatDataSec3[type].push('PptyWaterSystemSubTypeInfo');
        //this.flatDataSetSec3[type].push(item);   
        }else if(type=='privateLiftStations'){
          let item={"PptyWaterSystemType": "privateLiftStations",
            "WaterSystemOperationsDescription": "",
            "WaterSystemMaintenanceResponsiblePartyType": "",
            "WaterSystemMaintenanceResponsiblePartyName": "",
            "WaterSystemMaintenancePartyQualificationsDescription": ""
          }
          this.flatPartySetSec3[type]=item;
          this.flatDataSec3[type]=[];
          this.flatDataSetSec3[type]=[]; 
        }else if(type="privateWellsNonDrinkingWater"){
          let item={"PptyWaterSystemType": "privateWellsNonDrinkingWater",
          "WaterSystemOperationsDescription": ""};
          //this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].push(item);
          this.flatPartySetSec3[type]=[item];
          this.flatDataSec3[type]=['privateWellsNonDrinkingWater'];          
          this.flatDataSetSec3[type]=[item];         
        };
        this.frmData.waterCheck[index]=true;
        if(this.frmData.waterCheck[4]){
          this.frmData.waterCheck[4]=false;
        }        
      }else{
        this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment']=this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].filter(item => item.PptyWaterSystemType !=type);
        this.flatDataSec3[type]=[];
        this.flatDataSetSec3[type]=[];
        this.frmData.waterCheck[index]=false;
        delete this.flatPartySetSec3[type];
        
      }
            
    }else{
      if(e.target.checked){
        this.frmData.waterCheck=[false, false, false, false, true];
        let item={
          "PptyWaterSystemType": "privateWellsNonDrinkingWater",
          "WaterSystemOperationsDescription": ""
          }
        this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment']=[];
        this.flatDataSec3['privateWellsDrinkingWater']=[];
        this.flatDataSec3['privateWellsNonDrinkingWater']=[];
        this.flatDataSec3['wasteWaterTreatment']=[];
        this.flatDataSec3['privateLiftStations']=[];
        this.flatDataSetSec3['privateWellsDrinkingWater']=[];
        this.flatDataSetSec3['privateWellsNonDrinkingWater']=[];
        this.flatDataSetSec3['wasteWaterTreatment']=[];
        this.flatDataSetSec3['privateLiftStations']=[];
        this.flatPartySetSec3={}
      }
    }
    this.frmData['flatPartySetSec3']=this.flatPartySetSec3;
    this.frmOutput.emit(this.frmData);
  }
  addParty(e, dataset, value){
    if(e.target.checked){
      this.flatPartySetSec3[dataset].WaterSystemMaintenanceResponsiblePartyType=value;
      this.flatPartySetSec3[dataset].WaterSystemMaintenanceResponsiblePartyName=''
    }else{
      this.flatPartySetSec3[dataset].WaterSystemMaintenanceResponsiblePartyType='';
      this.flatPartySetSec3[dataset].WaterSystemMaintenanceResponsiblePartyName=''
    }
    this.frmOutput.emit(this.frmData);
  }
  addProperty(e, dataset, key, value?){

    if(value){
      if(this.flatDataSetSec3[dataset][0][key]){
        if(key=='WaterSystemMaintenanceResponsiblePartyType'){
          this.flatDataSetSec3[dataset][0]['WaterSystemMaintenanceResponsiblePartyName']='';
          this.flatDataSetSec3[dataset][0]['WaterSystemMaintenancePartyQualificationsDescription']='';
          if(e.target.checked){
            this.flatDataSetSec3[dataset][0]['WaterSystemMaintenanceResponsiblePartyType']=value;
          }else{
            this.flatDataSetSec3[dataset][0].splice(0,1);
          }
        }else{
          this.flatDataSetSec3[dataset][0][key]=value;
        }
        
      }else{
        let item={
          "PptyWaterSystemType": dataset,
          "WaterSystemOperationsDescription": "",
          "WaterSystemToMunicipalSystemConnectionDescription": "",
          "WaterSystemMaintenanceResponsiblePartyType": value,
          "WaterSystemMaintenanceResponsiblePartyName": "",
          //"WaterSystemMaintenanceResponsiblePartyName": "",
          "WaterSystemMaintenancePartyQualificationsDescription": ""
          }
        this.flatDataSetSec3[dataset].splice(0, 0, item);
      }
      
    }else{
      let index=this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].findIndex(item=>item['WaterSystemAsmntItemType']==key);console.log(index);
      let index1=this.flatDataSec3[dataset].indexOf(key);
      if(e.target.value=='Y'){
        if(index1==-1){
           let item={
            "PptyWaterSystemType": dataset,
            "WaterSystemAsmntItemType": key,
            "WaterSystemViolationInd": "Y",
            "WaterSystemViolationDescription": ""
            };
            this.flatDataSec3[dataset].push(key);
            this.flatDataSetSec3[dataset].push(item);
            this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].push(item);
        }
       
      }else if(e.target.value=='N'){
        if(index1>-1){
          this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].splice(index, 1);
          this.flatDataSetSec3[dataset].splice(index1, 1);
          this.flatDataSec3[dataset].splice(index1, 1);
          
        }
        
      }else{
        let index2=this.flatDataSec3[dataset].indexOf(key); //this.flatDataSetSec3[dataset].findIndex(item=>item['PptyWaterSystemSubType']==key); console.log(index2)
        let index3=this.flatDataSec3[dataset].indexOf('PptyWaterSystemSubTypeInfo');
        if(index2==-1){
          let item={
            "PptyWaterSystemType": dataset,
            "PptyWaterSystemSubType": key,
          };
          if(key=='septicSystem'){
            let index8=this.flatDataSec3[dataset].indexOf("sewageTreatmentPlant");
            let index9=this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].findIndex(item=>item.PptyWaterSystemSubType=="sewageTreatmentPlant");
            if(index8==-1){
              this.flatDataSec3[dataset].push(key);
              this.flatDataSetSec3[dataset].push(item);
              this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].push(item);
            }else{
              this.flatDataSec3[dataset].splice(index8, 0, key);
              this.flatDataSetSec3[dataset].splice(index8, 0, item);
              this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].splice(index9, 0, item);
            }
          }else if(key=='sewageTreatmentPlant'){
            let index8=this.flatDataSec3[dataset].indexOf("septicSystem");
            let index9=this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].findIndex(item=>item.PptyWaterSystemSubType=="septicSystem");

            if(index8==-1){
              this.flatDataSec3[dataset].push(key);
              this.flatDataSetSec3[dataset].push(item);
              this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].push(item);
            }else{
              this.flatDataSec3[dataset].splice(index8+1, 0, key);
              this.flatDataSetSec3[dataset].splice(index8+1, 0, item);
              this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].splice(index9+1, 0, item);
            }
          }
          
          /*if(index3==-1){
            let item={
              "PptyWaterSystemType": dataset,
              "WaterSystemOperationsDescription": "",
              "WastewaterLeachFieldDescription": "",
              "WastewaterEffluentDischargeDescription": "",
              "WaterSystemToMunicipalSystemConnectionDescription": "",
              "WaterSystemMaintenanceResponsiblePartyType": e.target.value,
              "WaterSystemMaintenanceResponsiblePartyName": "",
              //"WaterSystemMaintenanceResponsiblePartyName": "Name IV - 5",
              "WaterSystemMaintenancePartyQualificationsDescription": ""
              }
              //this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].push(item);
              this.flatDataSec3[dataset].push('PptyWaterSystemSubTypeInfo');
            this.flatDataSetSec3[dataset].push(item);
          }else{
            let index7=this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].findIndex(a=>a.PptyWaterSystemType==dataset&&a.WaterSystemMaintenanceResponsiblePartyType);
            if(e.target.checked){
              this.flatDataSetSec3[dataset][index3][key]=e.target.value;
              if(index7>-1){
                this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'][index7][key]=e.target.value;
              }
            }else{
              this.flatDataSetSec3[dataset].splice(index3,1);
              if(index7>-1){
                this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].splice(index7,1);
              }
            }
            
          }*/
        }else if(index2>-1){
          let index6=this.flatDataSec3[dataset].indexOf('PptyWaterSystemSubTypeInfo');
          let index0=this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].findIndex(item=>item.PptyWaterSystemSubType==key);

          this.flatDataSetSec3[dataset].splice(index2, 1);
          this.flatDataSec3[dataset].splice(index2, 1);
          this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].splice(index0, 1);
          let index4=this.flatDataSec3[dataset].indexOf('septicSystem'); 
          let index5=this.flatDataSec3[dataset].indexOf('sewageTreatmentPlant'); 
          if(index4==-1&&index5==-1){
            this.flatDataSetSec3[dataset]=[];//.splice(index6, 1);
            this.flatDataSec3[dataset]=[];//.splice(index6, 1);
            let item={
              "PptyWaterSystemType": "wasteWaterTreatment",
              "WaterSystemOperationsDescription": "",
              "WastewaterLeachFieldDescription": "",
              "WastewaterEffluentDischargeDescription": "",
              "WaterSystemToMunicipalSystemConnectionDescription": "",
              "WaterSystemMaintenanceResponsiblePartyType": "",
              "WaterSystemMaintenanceResponsiblePartyName": "",
              "WaterSystemMaintenancePartyQualificationsDescription": ""
              }
              this.flatPartySetSec3['wasteWaterTreatment']=item;
              this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment']=this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].filter(item => item.PptyWaterSystemType !='wasteWaterTreatment');
              this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].push(JSON.parse(JSON.stringify(this.flatPartySetSec3['wasteWaterTreatment'])));
          }else{
            if(index4==-1){
              this.flatPartySetSec3['wasteWaterTreatment']["WastewaterLeachFieldDescription"]="";
              this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment']=this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].filter(item => !item.PptyWaterSystemSubType&& item.PptyWaterSystemSubType!='sewageTreatmentPlant');
              let index9=this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].findIndex(item=>item.WastewaterLeachFieldDescription&&item.WastewaterLeachFieldDescription.length>0);
              if(index9>-1){
                this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'][index9].WastewaterLeachFieldDescription='';
              }
            }
            if(index5==-1){
              this.flatPartySetSec3['wasteWaterTreatment']["WastewaterEffluentDischargeDescription"]="";
              this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment']=this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].filter(item => !item.PptyWaterSystemSubType&&item.PptyWaterSystemSubType!='septicSystem');
              let index9=this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].findIndex(item=>item.WastewaterEffluentDischargeDescription&&item.WastewaterEffluentDischargeDescription.length>0);
              if(index9>-1){
                this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'][index9].WastewaterEffluentDischargeDescription='';
              }
            }            
          }
        }
      }
    }
    
    this.frmData['flatPartySetSec3']=this.flatPartySetSec3;
    this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment']=[]; 
    for(let i=0; i<this.frmData.waterCheck.length; i++){
      if(this.frmData.waterCheck[i]&&i<(this.frmData.waterCheck.length-1)){//console.log(this.frmData.waterCheck[i]); console.log(this.waters[i]);
       // if(this.flatPartySetSec3[this.waters[i]]){
       //   this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].push(this.flatPartySetSec3[this.waters[i]]);
       // }
        
        for(let j=0; j<this.flatDataSec3[this.waters[i]].length; j++){
          if(this.flatDataSec3[this.waters[i]][j]!='PptyWaterSystemSubTypeInfo'){
            this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment'].push(this.flatDataSetSec3[this.waters[i]][j])
          }
        }

      }else if(this.frmData.waterCheck[i]&&i==(this.frmData.waterCheck.length-1)){
        this.PropertyConditionAssessment[0]['PropertyConditionAssessmentWaterTreatment']=[];
      }
    }
    this.frmOutput.emit(this.frmData);
  }
  addProperty1(e, dataset, key, value?){

    if(!this.flatDataSetSec4[dataset]){
      this.flatDataSetSec4[dataset]=[];
    }
    if(dataset=='ManufacturedHousingUtility'){
      
      let index=this.PropertyConditionAssessment[0]['ManufacturedHousingUtility'].findIndex(item=>item['UtilityServiceType']==key);console.log(index);
      let index1=this.flatDataSec4[dataset].indexOf(key);
      if(e.target.checked){
        if(index==-1){
          let item={"UtilityServiceType": key};
          if(key=='other'){
            item['OtherTypeDescription']='';
          }
          this.PropertyConditionAssessment[0]['ManufacturedHousingUtility'].push(item);
          this.flatDataSec4[dataset].push(key);
          this.flatDataSetSec4[dataset].push(item);
        }
        
      }else{
        if(value){
          //this.flatDataSetSec4[dataset][index1]['OtherTypeDescription']=value;
          this.PropertyConditionAssessment[0]['ManufacturedHousingUtility'][index]['OtherTypeDescription']=this.flatDataSetSec4[dataset][index1]['OtherTypeDescription'];
        }else{
          if(index>-1){
            this.PropertyConditionAssessment[0]['ManufacturedHousingUtility'].splice(index, 1);
            this.flatDataSetSec4[dataset].splice(index1, 1);
            this.flatDataSec4[dataset].splice(index1, 1);
          }
        }
        

      }
      this.frmOutput.emit(this.frmData);
    return
    }
    
     let index=this.PropertyConditionAssessment[0]['PropertyConditionAssessmentManufacturedHousing'].findIndex(item=>item['ViolationType']==key);console.log(index);
      let index1=this.flatDataSec4[dataset].indexOf(key);
      if(value){
        if(this.flatDataSetSec4[dataset][index1][value]){
          this.flatDataSetSec4[dataset][index1][value]=e.target.value;
        }        
      }else{
      if(e.target.value=='Y'){
        if(index1==-1){
          let item:any;
          if(key=='padsWithUnpavedDriveways'){
            item={
              "ViolationInd": "Y",
              "ViolationType": "padsWithUnpavedDriveways",
              "ViolationDescription": "",
              "UnpavedDrivewayPadSiteWithCurrentlyOccupiedHomeInd": "N",
              "UnpavedDrivewayPadSiteWithCurrentlyOccupiedHomeCount": 0,
              "UnpavedDrivewayPadSiteWithVacantDownOfflineHomeInd": "N",
              "UnpavedDrivewayPadSiteWithVacantHomeCount": 0,
              "UnpavedDrivewayPadSiteNeverHadHomeCount": 0,
              "UnpavedDrivewayPadSiteWithPastNotPresentHomeCount": 0,
              "UnpavedDrivewayPadSiteTotalPavingCostAmt": 0
              }
              this.frmData['sec4OutPutData']=[0, 0,'$0'];
          }else{
            item={
            "ViolationInd": "Y",
            "ViolationType": key,
            "ViolationDescription": ""
            };
          }
           
            this.flatDataSec4[dataset].push(key);
            this.flatDataSetSec4[dataset].push(item);
            this.PropertyConditionAssessment[0]['PropertyConditionAssessmentManufacturedHousing'].push(item);
        }
       
      }else if(e.target.value=='N'){
        if(index1>-1){
          this.PropertyConditionAssessment[0]['PropertyConditionAssessmentManufacturedHousing'].splice(index, 1);
          this.flatDataSetSec4[dataset].splice(index1, 1);
          this.flatDataSec4[dataset].splice(index1, 1);
          
        }
        
      }
      }
      this.frmOutput.emit(this.frmData);
  }
  addProperty2(field, data){
    if(field=='ManufacturedHousingInd'){
      this.PropertyConditionAssessment[0].ManufacturedHousingInd=data;
      if(!this.flatDataSec4['PropertyConditionAssessmentManufacturedHousing']||(!this.flatDataSec4['ManufacturedHousingUtility'])||data=='N'){
        this.PropertyConditionAssessment[0]['PropertyConditionAssessmentManufacturedHousing']=[];
        this.flatDataSec4['PropertyConditionAssessmentManufacturedHousing']=[];
        this.PropertyConditionAssessment[0]['ManufacturedHousingUtility']=[];
        this.flatDataSec4["ManufacturedHousingUtility"]=[];
      }
    }
    this.frmOutput.emit(this.frmData);
  }
  addTitle(e, field){
    this.frmData[field]=e.target.value;
    this.frmOutput.emit(this.frmData);
  }
  scrollTo(id, e){
    if(e && e.target){
			e.stopPropagation();      
		}
    this.scrollOutput.emit(id+'content');
  }
  trackByFuntion(index, item) {
		return index;
	}
  addListParties(e){
    if(e && e.target){
			e.stopPropagation();
		}
    let item= {
      "Name":"",
      "Title":"",
      "Company":"",
      "Affiliation":"",
      "Comments":"",
    };
    this.frmData.ListOfParties.push(item);
    this.frmOutput.emit(this.frmData);
  }
  deleteListParties(e){
    if(e && e.target){
			e.stopPropagation();
		}
    Swal.fire({
			icon:'warning',
			title: 'This will erase the last line. Is this what you want to do?',
			confirmButtonText: 'Yes',
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
      if(this.frmData.ListOfParties.length>1){
        this.frmData.ListOfParties.pop();
      }else{
        let item= {
          "Name":"",
          "Title":"",
          "Company":"",
          "Affiliation":"",
          "Comments":"",
        };
        this.frmData.ListOfParties[this.frmData.ListOfParties.length-1]=item;
      }
      
    }
  })
    
  }
  toZoom(index, e){
    if(e && e.target){
			e.stopPropagation();
      //e.preventDefault();
		}
    this.zoom.emit(index);
  }
  sec3Check(status){
    if(status=='Y'){
      this.repairtCount[5]=true;
    }else{
      for(let i=0; i<6; i++)
      this.repairtCount[i]=false;
    }
    this.frmOutput.emit(this.frmData);
  }
  saverepairtCount(){
    this.frmData['repairtCount']= this.repairtCount;
    this.frmOutput.emit(this.frmData);    
  }
  calUnpavedCost(field){
    let index=this.flatDataSec4.PropertyConditionAssessmentManufacturedHousing.indexOf('padsWithUnpavedDriveways');console.log(index);
    this.frmData['sec4OutPutData']=[0, 0,'$0'];
    if(index>-1){
      let item=this.flatDataSetSec4.PropertyConditionAssessmentManufacturedHousing[index];
      if(item.UnpavedDrivewayPadSiteTotalPavingCostAmt>0){
        
        item.UnpavedDrivewayPadSiteTotalPavingCostAmt=this.getRound1(item.UnpavedDrivewayPadSiteTotalPavingCostAmt,2);
      }else{
        item.UnpavedDrivewayPadSiteTotalPavingCostAmt=0;
      }
      if(field!=='UnpavedDrivewayPadSiteTotalPavingCostAmt'){
      if(item[field]<0){
        item[field]=0
      }else{
        item[field]=this.getRound1(item[field],0)
      }
    }
      let vacantUnpave=this.getRound1(item.UnpavedDrivewayPadSiteWithVacantHomeCount+item.UnpavedDrivewayPadSiteNeverHadHomeCount+item.UnpavedDrivewayPadSiteWithPastNotPresentHomeCount,0);
      this.frmData['sec4OutPutData'][0]=vacantUnpave
      let allUnpavedNo=this.getRound1(item.UnpavedDrivewayPadSiteWithCurrentlyOccupiedHomeCount+item.UnpavedDrivewayPadSiteWithVacantHomeCount+item.UnpavedDrivewayPadSiteNeverHadHomeCount+item.UnpavedDrivewayPadSiteWithPastNotPresentHomeCount,0);
      this.frmData['sec4OutPutData'][1]=allUnpavedNo;
      if(allUnpavedNo>1){
        let unitCost='$'+this.getRound1(item.UnpavedDrivewayPadSiteTotalPavingCostAmt/allUnpavedNo, 2);
        this.frmData['sec4OutPutData'][2]=unitCost;
      }
          
    }  
    this.frmOutput.emit(this.frmData);
  }
  setCurSec(e, id){
    if(e && e.target){
			e.stopPropagation();
      //e.preventDefault();
		}
    if(id!=this.lockId){
      this.secSwitch.emit(id)
    }
  }
  secToFrmData(sec){
    let data=sec.data;
		const dataset=this.frmService.secDataSet[sec.id];
	 
		if(dataset){
			let keys=Object.keys(dataset);
			for(let key of keys){
				let val=dataset[key];
				if(data[key]){
					if(val.length>0){
						for(let item of val){
							if(key==='PropertyConditionAssessment'){
								if(data[key][0][item]&&data[key][0][item]!==this.frmData[key][0][item]){
									this.frmData[key][0][item]=JSON.parse(JSON.stringify(data[key][0][item]));
								}
								
							}else{
								if(data[key][item]&&data[key][item]!==this.frmData[key][item]){
									this.frmData[key][item]=JSON.parse(JSON.stringify(data[key][item]));
								}
							}
						}
					}else{
						if(data[key]!==this.frmData[key]){
							this.frmData[key]=JSON.parse(JSON.stringify(data[key]));
						}
					}
				}
			}
    }
     // switch(sec.id){
      //  case 'frm_sec0':       
          
        if(this.frmData['AccountNameHTML']){
            this.AccountNameHTML=this.frmData['AccountNameHTML'];
          }
          if(this.frmData['flatPartySetSec3']){
          this.flatPartySetSec3=this.frmData['flatPartySetSec3'];
        }
        if(this.frmData['repairtCount']){
         this.repairtCount= this.frmData['repairtCount'];
        }
          this.PropertyAsReportedHTML=this.frmData.PropertyAsReportedHTML;
          this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML=this.frmData.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML;
          this.PropertyConditionAssessmentHTML=this.frmData.PropertyConditionAssessmentHTML;
          this.toSanitizer();
          this.PropertyAmenity=this.frmData.PropertyAmenity;
          this.PropertyAsReported=this.frmData.PropertyAsReported;
          
          this.PropertyConditionAssessmentPropertyCoreCharacteristics=this.frmData.PropertyConditionAssessmentPropertyCoreCharacteristics;
          
          this.PropertyConditionAssessment=this.frmData.PropertyConditionAssessment;
          
          this.PropertyTotalRentRollSummary=this.frmData.PropertyTotalRentRollSummary;
          this.toFlat(this.PropertyConditionAssessment[0]);
          if(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.length==0){
            let item={
              "UnitType": "",
              "SlrDesignatedUnitId": "",
              "OccupancyStatusType": ""
            }
            for(let i=0; i<20; i++){
              this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.push(JSON.parse(JSON.stringify(item)));
            }
            this.unitrow=5
          }else{
            this.unitrow=Math.ceil(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.length/4); 
            if(this.unitrow<5) {
              this.unitrow=5
            }    
          };
        
         // break;
       // case 'frm_sec2':
          /*if(this.frmData['repairtCount']){
            this.repairtCount= this.frmData['repairtCount'];
          }
       // break;
      //  case 'frm_sec3':
          if(this.frmData['flatPartySetSec3']){
            this.flatPartySetSec3=sec.data['flatPartySetSec3'];
          }
       // break;
       // case 'frm_sec4':
          let items=dataset['frm_sec4']['PropertyConditionAssessment'];
          for(let item of items){
            if(sec.data['PropertyConditionAssessment'][0][item]&&sec.data['PropertyConditionAssessment'][0][item]!==this.frmData['PropertyConditionAssessment'][0][item]){
              this.frmData['PropertyConditionAssessment'][0][item]=JSON.parse(JSON.stringify(sec.data['PropertyConditionAssessment'][0][item]));
            }
          }
          this.frmData['sec4OutPutData']=sec.data['sec4OutPutData'];*/
       // break;
     // }		
  }		
  onComponentBlur() {
    this.frmOutput.emit(this.frmData);
  }
}
